import React from 'react';

const Footer = ({ className = "mt-0" }) => {
  return (
    <footer className={`bg-black text-white py-12 px-6 ${className}`}>
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-gray-400 text-sm">
          © {new Date().getFullYear()} Slick Signature.{' '}
          <a 
            href="https://www.onlinedesignclub.com/services/website-design-development/" 
            className="hover:text-white transition-colors" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            WordPress Website Design by Online Design Club
          </a>.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
